// extracted by mini-css-extract-plugin
export default {"input":"select_input__npuYz","inputWithValues":"select_inputWithValues__qn3ed","multiplyInput":"select_multiplyInput__+W8tP"};